require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");


require("./vendor/owl.carousel.min.js");


(function ($) {
    $(document).ready(function () {
        // Sticky Header
        $(window).scroll(function () {
            if ($(window).scrollTop() > 50) {
                $('header').addClass('sticky');
            } else {
                $('header').removeClass('sticky');
            }
        });

        // Smooth Scroll
        function scrollToHash(hash) {
            if (!hash || hash === '#') return false;
            const target = $(hash);
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 80
                }, 500, 'linear');
                return true;
            }
            return false;
        }

        $('a[href*="#"]').not('[data-toggle="collapse"]').on('click', function (e) {
            const href = $(this).attr('href');
            // Check if it's just a hash or a link to the current page
            const isLocal = href.startsWith('#') || href.split('#')[0] === window.location.href.split('#')[0];

            if (isLocal) {
                const targetHash = href.substring(href.indexOf('#'));
                if (scrollToHash(targetHash)) {
                    e.preventDefault();
                }
            }
            // If NOT local, the browser will navigate to the other page normally
        });

        // Scroll on load if hash exists (handles transition from other pages)
        $(window).on('load', function () {
            if (window.location.hash) {
                setTimeout(() => {
                    scrollToHash(window.location.hash);
                }, 600);
            }
        });

        if ($('.why_choose_slider').length) {
            require("./why_choose_slider.es6");
        }
        if ($('.reviews_slider').length) {
            require("./reviews_slider.es6");
        }
        if ($('.demo_audio_slider').length) {
            require("./demo_audio_slider.es6");
        }
        if ($('.blog_posts_slider').length) {
            require("./blog_slider.es6");
        }
        if ($('.gift_options').length) {
            require("./gift_options.es6");
        }

        // Close the blog category dropdown when clicking outside of it
        $(document).on('click', function (e) {
            $('.blog_filter_category[open]').each(function () {
                if (!this.contains(e.target)) {
                    this.removeAttribute('open');
                }
            });
        });
    });
})(jQuery);